/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import Button from "@mui/material/Button";
import MDTypography from "components/MDTypography";
import React, { useState } from "react";
import toast from "react-hot-toast";
import InputFileUpload from "./InputFile";
import { Divider } from "@mui/material";

function DocumentacionClinica({ Back, Next, props, vista = "registrar" }) {
  const defaultEstudio = { nombre: "", archivo: null, error: false };

  const [estudios, setEstudios] = useState(() => {
    // Crea un array de 15 elementos con valores por defecto
    const base = Array.from({ length: 15 }, () => ({ ...defaultEstudio }));

    // Sobrescribe con los estudiosGuardados (hasta donde haya)
    props.forEach((estudio, index) => {
      base[index] = {
        nombre: estudio.titulo || "",
        archivo: estudio.file || null,
      };
    });

    return base;
  });

  const ValidaForm = () => {
    let valido = true;

    const nuevosEstudios = estudios.map((est) => {
      if (est.archivo && !est.nombre) {
        valido = false;
        return { ...est, error: true };
      }
      return { ...est, error: false };
    });

    setEstudios(nuevosEstudios);

    if (!valido) {
      toast.error("Nombre de archivo obligatorio *");
      return false;
    }

    // Archivos no nulos
    const files = nuevosEstudios
      .filter((est) => est.archivo)
      .map((est) => ({
        titulo: est.nombre.trim(),
        file: est.archivo,
      }));

    // Validar archivos duplicados por nombre de archivo
    const nameMap = {};
    const titleMap = {};
    files.forEach((fileObj) => {
      const fileName = fileObj.file.name.trim().toLowerCase();
      const titleName = fileObj.titulo.trim().toLowerCase();

      nameMap[fileName] = (nameMap[fileName] || 0) + 1;
      titleMap[titleName] = (titleMap[titleName] || 0) + 1;
    });

    const duplicatesFileNames = Object.entries(nameMap).filter(([_, count]) => count > 1);
    const duplicatesTitles = Object.entries(titleMap).filter(([_, count]) => count > 1);

    if (duplicatesFileNames.length > 0 || duplicatesTitles.length > 0) {
      duplicatesFileNames.forEach(([name]) => {
        toast.error(`Archivo duplicado: ${name}`);
      });

      duplicatesTitles.forEach(([title]) => {
        toast.error(`Nombre de estudio duplicado: ${title}`);
      });

      return false;
    }

    // Si todo está validado, continúa
    Next(files);
  };

  const handleBack = () => {
    let valido = true;

    const nuevosEstudios = estudios.map((est) => {
      if (est.archivo && !est.nombre) {
        valido = false;
        return { ...est, error: true };
      }
      return { ...est, error: false };
    });

    setEstudios(nuevosEstudios);

    if (!valido) {
      toast.error("Nombre de archivo obligatorio *");
      return false;
    }

    // Archivos no nulos
    const files = nuevosEstudios
      .filter((est) => est.archivo)
      .map((est) => ({
        titulo: est.nombre.trim(),
        file: est.archivo,
      }));

    // Validar archivos duplicados por nombre de archivo
    const nameMap = {};
    const titleMap = {};
    files.forEach((fileObj) => {
      const fileName = fileObj.file.name.trim().toLowerCase();
      const titleName = fileObj.titulo.trim().toLowerCase();

      nameMap[fileName] = (nameMap[fileName] || 0) + 1;
      titleMap[titleName] = (titleMap[titleName] || 0) + 1;
    });

    const duplicatesFileNames = Object.entries(nameMap).filter(([_, count]) => count > 1);
    const duplicatesTitles = Object.entries(titleMap).filter(([_, count]) => count > 1);

    if (duplicatesFileNames.length > 0 || duplicatesTitles.length > 0) {
      duplicatesFileNames.forEach(([name]) => {
        toast.error(`Archivo duplicado: ${name}`);
      });

      duplicatesTitles.forEach(([title]) => {
        toast.error(`Nombre de estudio duplicado: ${title}`);
      });

      return false;
    }

    // Si todo está validado, continúa
    Back(files);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDBox textAlign="center">
            <MDTypography variant="h5" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
              Por favor cargue todos los estudios con los que cuente el menor relacionados a la
              posible sordera.
            </MDTypography>
          </MDBox>
          <br />
          <MDBox textAlign="left">
            <MDTypography color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
              Nota: En caso de subir un estudio, debe colocar el nombre.
            </MDTypography>
          </MDBox>
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      {estudios.map((estudio, index) => (
        <React.Fragment key={index}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={2}>
              <MDBox textAlign="right">
                <MDTypography
                  variant="h6"
                  color="white"
                  style={{ opacity: 0.7, fontSize: "0.9rem" }}
                >
                  Estudio {index + 1}:
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={10}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                  <TextField
                    value={estudio.nombre}
                    onChange={(event) => {
                      const nuevos = [...estudios];
                      nuevos[index].nombre = event.target.value;
                      nuevos[index].error = false;
                      setEstudios(nuevos);
                    }}
                    onBlur={() => {
                      if (!estudio.nombre && estudio.archivo != null) {
                        const nuevos = [...estudios];
                        nuevos[index].error = true;
                        setEstudios(nuevos);
                      }
                    }}
                    error={estudio.error}
                    helperText={estudio.error ? `Ingrese el nombre del estudio ${index + 1}*` : ""}
                    label={`Nombre del estudio ${index + 1}`}
                    variant="outlined"
                    fullWidth
                    size="small"
                    autoComplete="off"
                    InputLabelProps={{ shrink: true }}
                    style={{ marginBottom: "1.5rem" }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputFileUpload
                    onchangeFile={(file) => {
                      const nuevos = [...estudios];
                      nuevos[index].archivo = file;
                      if (!nuevos[index].nombre) nuevos[index].error = true;
                      setEstudios(nuevos);
                    }}
                    valueF={estudio.archivo}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
        </React.Fragment>
      ))}

      {vista === "visualizar" ? null : (
        <MDBox textAlign="right">
          <Button
            variant="contained"
            onClick={() => ValidaForm()}
            sx={{ mt: 1, mr: 1 }}
            size="small"
            color="primary"
          >
            Continuar
          </Button>
          <Button
            variant="contained"
            onClick={() => handleBack()}
            sx={{ mt: 1, mr: 1 }}
            size="small"
            color="secondary"
          >
            Volver
          </Button>
        </MDBox>
      )}
    </>
  );
}

export default DocumentacionClinica;
